import script from "./FilterIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./FilterIcon.vue?vue&type=script&setup=true&lang=ts"

import "./FilterIcon.vue?vue&type=style&index=0&id=3b0a37c8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b0a37c8"]])

export default __exports__